<template>
  <div class="big">
    <div class="page_title flex between">
      <span>医生分享详情</span>
      <el-button type="primary" style="width: 92px" size="medium" @click="back"
        >返回</el-button
      >
    </div>
    <div style="padding: 20px; border-radius: 5px">
      <div class="container">
        <div>
          <div class="box" style="padding-top: 20px">
            <div class="top padding20" style="background: #f2f2f2">
              <div class="flex align-center bottom20">
                <div class="flex align-center right20">
                  <div class="right20 bold">医生姓名</div>
                  <div>{{ info.doctor_name }}</div>
                </div>
                <div class="flex align-center right20">
                  <div class="right20 bold">性别</div>
                  <div>{{ info.sex == "1" ? "男" : "女" }}</div>
                </div>
                <div class="flex align-center right20">
                  <div class="right20 bold">手机号</div>
                  <div>{{ info.doctor_phone }}</div>
                </div>
              </div>
              <div class="flex align-center bottom20">
                <div class="flex align-center right20">
                  <div class="right20 bold">科室</div>
                  <div>{{ info.department_name }}</div>
                </div>
                <div class="flex align-center right20">
                  <div class="right20 bold">职称</div>
                  <div>{{ info.title }}</div>
                </div>
                <div class="flex align-center right20">
                  <div class="right20 bold">医院</div>
                  <div>{{ info.hospital }}</div>
                </div>
                <div class="flex align-center right20">
                  <div class="right20 bold">关注人数</div>
                  <div>{{ info.count }}</div>
                </div>
              </div>
              <div class="flex align-center bottom20">
                <div class="right20 bold">医生分享渠道</div>
                <el-button type="primary" @click="addShow = true"
                :disabled="
                    module_id_array[0]
                      ? !module_id_array.includes('1147')
                      : false
                  "
                  >添加渠道</el-button
                >
              </div>
              <div
                v-for="(item, index) in info.from"
                :key="index"
                class="flex bottom20"
              >
                <div class="right20">{{ item.from_name }}</div>
                <div class="right20">{{ item.url }}</div>
                <div
                  class="right20 pointer"
                  style="color: #669961"
                  @click="copyUrl(item.url)"
                >
                  复制链接
                </div>
                <div
                  class="right20 pointer"
                  style="color: #669961"
                  @click="download(item.qr_code)"
                >
                  下载二维码
                </div>
              </div>
            </div>
            <div class="searchbox">
              <div class="item">
                <span>用户昵称</span>
                <el-input
                  placeholder="请输入"
                  v-model="nick_name"
                  style="width: 160px; margin-left: 12px"
                  clearable
                ></el-input>
              </div>
              <div class="item">
                <span>用户手机号</span>
                <el-input
                  placeholder="请输入"
                  v-model="phone"
                  style="width: 160px; margin-left: 12px"
                  clearable
                ></el-input>
              </div>
              <div class="item">
                <span>用户注册时间</span>
                <el-date-picker
                  v-model="date1"
                  type="daterange"
                  range-separator="~"
                  start-placeholder="开始时间"
                  end-placeholder="结束时间"
                  style="width: 264px; margin-left: 12px"
                  clearable
                ></el-date-picker>
              </div>
              <div class="item">
                <span>关注时间</span>
                <el-date-picker
                  v-model="date2"
                  type="daterange"
                  range-separator="~"
                  start-placeholder="开始时间"
                  end-placeholder="结束时间"
                  style="width: 264px; margin-left: 12px"
                  clearable
                ></el-date-picker>
              </div>
              <div class="item">
                <span>渠道来源</span>
                <el-select
                  style="width: 160px; margin-left: 12px"
                  v-model="from_id"
                  placeholder="请选择"
                >
                  <el-option
                    :label="item.from_name"
                    :value="item.from_id"
                    v-for="(item, index) in shareFromData"
                    :key="index"
                  >
                  </el-option>
                </el-select>
              </div>
              <div class="item flex align-center">
                <span>医生是否得奖</span>
                <el-radio-group v-model="is_money" style="margin: 0 12px 0 8px">
                  <el-radio label="">全部</el-radio>
                  <el-radio label="1">是</el-radio>
                  <el-radio label="0">否</el-radio></el-radio-group
                >
              </div>
              <div class="item">
                <span>咨询次数</span>
                <el-input-number
                  v-model="agree_times_start"
                  :min="1"
                  :precision="1"
                  style="width: 90px; margin-left: 12px"
                  :controls="false"
                ></el-input-number>
                <span style="margin: 0 5px">-</span>
                <el-input-number
                  v-model="agree_times_end"
                  :min="1"
                  :precision="1"
                  style="width: 90px"
                  :controls="false"
                ></el-input-number>
              </div>
              <div class="item">
                <span>购药次数</span>
                <el-input-number
                  v-model="pay_pre_times_start"
                  :min="1"
                  :precision="1"
                  style="width: 90px; margin-left: 12px"
                  :controls="false"
                ></el-input-number>
                <span style="margin: 0 5px">-</span>
                <el-input-number
                  v-model="pay_pre_times_end"
                  :min="1"
                  :precision="1"
                  style="width: 90px"
                  :controls="false"
                ></el-input-number>
              </div>
            </div>

            <div class="searchbox">
              <el-button type="primary" @click="derive"  :disabled="
                    module_id_array[0]
                      ? !module_id_array.includes('1149')
                      : false
                  ">导出</el-button>
              <el-button
                type="info"
                @click="search"
                style="
                  background-color: #eceff2;
                  color: #747981;
                  margin-left: 30px;
                "
                >查询</el-button
              >
            </div>
            <div style="border: solid 1px #c9cbd6">
              <el-table
                ref="multipleTable"
                :data="tableData"
                tooltip-effect="dark"
                style="width: 100%; min-width: 1000px"
                :header-cell-style="{ background: '#F5F5F5' }"
                @sort-change="changeOrder"
              >
                <el-table-column label="用户信息">
                  <template slot-scope="scope">
                    <div>{{ scope.row.nick_name }}</div>
                    <div>{{ scope.row.phone }}</div>
                    <div v-if="scope.row.cancel_id > 0" class="red">
                      曾经注销
                    </div>
                  </template>
                </el-table-column>
                <el-table-column label="用户本人信息">
                  <template slot-scope="scope">
                    <div>
                      <span>{{ scope.row.real_name }}</span>
                      <span v-if="scope.row.sex == 1" style="margin-left: 16px"
                        >男</span
                      >
                      <span v-if="scope.row.sex == 2" style="margin-left: 16px"
                        >女</span
                      >
                    </div>
                    <div>
                      <span>{{ scope.row.age }}</span>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column
                  label="注册时间"
                  prop="reg_time"
                  sortable="custom"
                ></el-table-column>
                <el-table-column
                  label="关注时间"
                  prop="create_time"
                  sortable="custom"
                ></el-table-column>
                <el-table-column label="渠道来源" prop="from_name">
                </el-table-column>

                <el-table-column label="医生是否得奖">
                  <template slot-scope="scope">
                    <div v-if="scope.row.is_money == 1">是</div>
                    <div v-if="scope.row.is_money == 0">否</div>
                  </template>
                </el-table-column>
                <el-table-column
                  label="咨询次数"
                  prop="agree_times"
                  sortable="custom"
                ></el-table-column>
                <el-table-column
                  label="购药次数"
                  prop="pay_pre_times"
                  sortable="custom"
                ></el-table-column>
                <el-table-column label="操作">
                  <template slot-scope="scope">
                    <el-button
                      type="text"
                      @click="toDetail(scope.row.user_id)"
                      :disabled="
                        module_id_array[0]
                          ? !module_id_array.includes('50')
                          : false
                      "
                      >查看详情</el-button
                    >
                    <el-button
                      type="text"
                      @click="showShareFrom(scope.row)"
                      :disabled="
                        module_id_array[0]
                          ? !module_id_array.includes('1148')
                          : false
                      "
                      >更改渠道</el-button
                    >
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div>
              <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                :page-sizes="[10, 20, 50, 100]"
                :page-size="10"
                layout="total, sizes, prev, pager, next, jumper"
                :total="totalNum"
                style="margin: 20px 0"
              ></el-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog title="提示" :visible.sync="changeShow" width="500px">
      <div class="content padding20">
        <div class="flex center bottom20">
          当前用户渠道 ：{{ activeInfo.from_name }}
        </div>
        <div class="flex center align-center">
          更改为：<el-select
            style="width: 160px; margin-left: 12px"
            v-model="changeInfo"
            placeholder="请选择"
            value-key="from_id"
          >
            <el-option
              :label="item.from_name"
              :value="item"
              v-for="(item, index) in selectFromData"
              :key="index"
            >
            </el-option>
          </el-select>
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="changeShow = false">取 消</el-button>
        <el-button type="primary" @click="changeDoctorShareFrom"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <el-dialog title="添加渠道" :visible.sync="addShow" width="500px">
      <div class="content padding20">
        <div class="flex center align-center">
          请选择渠道：<el-select
            style="width: 160px; margin-left: 12px"
            v-model="changeInfo"
            placeholder="请选择"
            value-key="from_id"
          >
            <el-option
              :label="item.from_name"
              :value="item"
              v-for="(item, index) in selectFromData"
              :key="index"
            >
            </el-option>
          </el-select>
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="addShow = false">取 消</el-button>
        <el-button type="primary" @click="addDoctorShareFrom">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import dayjs from "dayjs";
import DocMsg from "../../../components/common/DocMsg.vue";

export default {
  data() {
    return {
      doctorId: this.$route.query.doctor_id,
      info: {},
      totalNum: 0,
      currentPage: 1,
      pagesize: 10,
      tableData: [],
      nick_name: "",
      phone: "",
      agree_times_start: undefined,
      agree_times_end: undefined,
      pay_pre_times_start: undefined,
      pay_pre_times_end: undefined,
      date1: [],
      date2: [],
      order_key: "",
      order_value: "",
      labelList: [],
      doc_msg: false,
      from_id: "",
      multipleSelection: [],
      importData: false,
      shareFromData: [],
      from_id: "",
      is_money: "",
      changeShow: false,
      selectFromData: [],
      activeInfo: {}, //当前要更改的信息
      changeInfo: {}, //改后的信息
      addShow: false,
    };
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    },
  },
  components: {
    DocMsg,
  },
  methods: {
    //医生信息概要
    showDocMsg(doctor_id) {
      this.doctorId = doctor_id;
      this.doc_msg = !this.doc_msg;
    },
    //获取详情
    getDoctorShareDetail() {
      let data = {
        doctor_id: this.doctorId,
      };
      this.axios
        .post("platform/Doctor/getDoctorShareDetail", data)
        .then((res) => {
          this.info = res.data;
        });
    },
    //获取列表
    getList() {
      let data = {
        doctor_id: this.doctorId,
        page: this.currentPage,
        pageNumber: this.pagesize,
        nick_name: this.nick_name,
        phone: this.phone,
        agree_times_start: this.agree_times_start,
        agree_times_end: this.agree_times_end,
        pay_pre_times_start: this.pay_pre_times_start,
        pay_pre_times_end: this.pay_pre_times_start,
        order_key: this.order_key,
        order_value: this.order_value,
        is_money: this.is_money,
      };
      if (this.date1 && this.date1.length > 0) {
        data.register_time_start = dayjs(this.date1[0]).format("YYYY-MM-DD");
        data.register_time_end = dayjs(this.date1[1]).format("YYYY-MM-DD");
      }
      if (this.date2 && this.date2.length > 0) {
        data.create_time_start = dayjs(this.date2[0]).format("YYYY-MM-DD");
        data.create_time_end = dayjs(this.date2[1]).format("YYYY-MM-DD");
      }

      this.axios
        .post("platform/doctor/getDoctorShareDetailList", data)
        .then((res) => {
          if (res.code == 0) {
            if (!res.data.list.length && this.currentPage > 1) {
              this.currentPage = this.currentPage - 1;
              this.getList();
            }
            this.tableData = res.data.list.map((item) => {
              item.create_time = dayjs
                .unix(item.create_time)
                .format("YYYY-MM-DD HH:mm");
              item.reg_time = dayjs
                .unix(item.reg_time)
                .format("YYYY-MM-DD HH:mm");
              return item;
            });
            this.totalNum = res.data.total;
          }
        });
    },
    search() {
      this.currentPage = 1;
      this.getList();
    },
    //每页数据的条数
    handleSizeChange(size) {
      this.pagesize = size;
      this.getList();
    },
    //当前第几页
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      this.getList();
    },
    changeOrder(value) {
      this.order_key = value.prop;
      //升序
      if (value.order == "ascending") {
        this.order_value = "asc";
      }
      //降序
      if (value.order == "descending") {
        this.order_value = "desc";
      }
      if (!value.order) {
        this.order_key = "";
        this.order_value = "";
      }
      this.getList();
    },
    //详情
    toDetail(id) {
      this.$router.push({
        name: "userdetail",
        query: {
          user_id: id,
        },
      });
    },
    back() {
      history.back();
    },
    getShareFromData() {
      this.axios.post("platform/Admin/getShareFromData").then((res) => {
        this.shareFromData = [
          {
            from_id: "",
            from_name: "全部",
          },
          ...res.data.value,
        ];
        this.selectFromData = res.data.value;
      });
    },
    //导出
    derive() {
      let data = {
        doctor_id: this.doctorId,
        page: this.currentPage,
        pageNumber: this.pagesize,
        nick_name: this.nick_name,
        phone: this.phone,
        agree_times_start: this.agree_times_start,
        agree_times_end: this.agree_times_end,
        pay_pre_times_start: this.pay_pre_times_start,
        pay_pre_times_end: this.pay_pre_times_start,
        order_key: this.order_key,
        order_value: this.order_value,
        is_money: this.is_money,
      };
      if (this.date1 && this.date1.length > 0) {
        data.register_time_start = dayjs(this.date1[0]).format("YYYY-MM-DD");
        data.register_time_end = dayjs(this.date1[1]).format("YYYY-MM-DD");
      }
      if (this.date2 && this.date2.length > 0) {
        data.create_time_start = dayjs(this.date2[0]).format("YYYY-MM-DD");
        data.create_time_end = dayjs(this.date2[1]).format("YYYY-MM-DD");
      }
      let loading = this.$loading();
      this.axios
        .post("platform/doctor/exportDoctorShareDetailList", data)
        .then((res) => {
          if (res.code == 0) {
            let host =
              document.location.protocol +
              "//" +
              window.location.host +
              res.data.url;
            window.open(host);
          }
          loading.close();
        })
        .catch((err) => {
          loading.close();
        });
    },
    //展示更改渠道
    showShareFrom(row) {
      this.activeInfo = row;
      this.changeShow = true;
    },
    //更改渠道
    changeDoctorShareFrom() {
      if (!this.changeInfo.from_id) {
        this.$message.error("请选择要更改的渠道");
        return;
      }
      let data = {
        log_id: this.activeInfo.log_id,
        from_id: this.changeInfo.from_id,
        from_name: this.changeInfo.from_name,
      };
      this.axios
        .post("platform/Doctor/changeDoctorShareFrom", data)
        .then((res) => {
          this.$message.success("修改成功");
          this.changeShow = false;
          this.getList();
          this.changeInfo = {};
        });
    },
    //添加渠道
    addDoctorShareFrom() {
      if (!this.changeInfo.from_id) {
        this.$message.error("请选择要添加的渠道");
        return;
      }
      let data = {
        doctor_id: this.doctorId,
        from_id: this.changeInfo.from_id,
        from_name: this.changeInfo.from_name,
      };
      this.axios
        .post("platform/Doctor/addDoctorShareFrom", data)
        .then((res) => {
          this.$message.success("添加成功");
          this.addShow = false;
          this.getDoctorShareDetail();
          this.changeInfo = {};
        });
    },
    //打开链接
    copyUrl(url) {
      let oInput = document.createElement("input");
      oInput.value = url;
      document.body.appendChild(oInput);
      oInput.select();
      document.execCommand("Copy");
      oInput.remove();
      this.$message({
        message: "复制成功",
        type: "success",
      });
    },
    //下载文件
    download(url) {
      window.open(url);
    },
  },
  created() {
    this.getShareFromData();
    this.getList();
    this.getDoctorShareDetail();
  },
  // activated() {
  //   this.getList();
  //   this.getDoctorShareDetail();
  // },
};
</script>
<style lang="scss" scoped>
.container {
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
}

.box {
  width: 100%;
  box-sizing: border-box;
  padding: 0 20px 1px 20px;
  .searchbox {
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 20px;
    .item {
      margin-right: 30px;
      margin-top: 24px;
      display: flex;
      align-items: center;
    }
  }
}
.videobox {
  width: 100px;
  height: 70px;
  position: relative;
  cursor: pointer;
  .videoimg {
    width: 100%;
    height: 100%;
  }
  .onvideo {
    width: 30px;
    position: absolute;
    top: 20px;
    left: 35px;
  }
}
.imgbox {
  display: flex;
  padding: 30px;
  box-sizing: border-box;
  justify-content: space-between;
}
.dialog {
  padding: 20px 20px 0;
}
</style>
